export const forbiddenTitleText = 'Halaman Tidak Dapat Diakses';
export const forbiddenDescText = 'Kamu tidak memiliki akses ke halaman ini.';
export const forbiddenLoggedIn = 'Silakan kembali ke dashboard.';
export const forbiddenDescMobileText = 'Akun kamu hanya memiliki akses versi desktop. Silakan buka halaman ini menggunakan PC atau laptop.';
export const forbiddenDescDesktopText = 'Akun kamu hanya memiliki akses versi mobile. Silakan buka halaman ini menggunakan handphone atau tab.';
export const logoutText = 'Logout';
export const loginText = 'Login';
export const dashboardText = 'Dashboard';
export const relogText = 'Jika masih tidak dapat masuk, silakan';
export const relogLinkText = 'login ulang';
